export const environment = {
  production: true,
  firebase : {
    apiKey: 'AIzaSyDuhH83Ahfl8Vo-iqngeimjXPXDGsnWr10',
    authDomain: 'medabi.firebaseapp.com',
    databaseURL: 'https://medabi.firebaseio.com',
    projectId: 'medabi',
    storageBucket: 'medabi.appspot.com',
    messagingSenderId: '785889607871',
    appId: '1:785889607871:web:9db9e6cecbf2f44ca1460a',
    measurementId: 'G-SRNQHP75NV'

  }
};
